<template>
  <div id="pageRomaneio">
    <v-btn
      class="btn-feedback"
      small
      absolute
      top
      right
      :to="{name : 'Feedback'}"
      color="info">
      <v-icon>fa-comment-alt</v-icon>
      &nbsp;&nbsp;
      <span>Feedback</span>
    </v-btn>
    <v-container  grid-list-lg fluid>      
      <v-layout row wrap v-if="romaneio">
        <v-flex xs12 md6>
          <v-card height="100%">
            <v-card-title primary-title>
              <div class="title">Local do abate</div>
            </v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs8 md6>
                  <div>{{romaneio.industry.name}}</div>
                  <div>{{romaneio.industry.address_city}}/{{romaneio.industry.address_state}}</div>
                </v-flex>
                <v-flex xs4 md6>
                  <v-img v-if="romaneio.industry && romaneio.industry.logo" 
                    :src="romaneio.industry.logo" 
                    :height="50"
                    :contain="true"
                    alt="Logo"></v-img>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
         <v-flex xs12 md6>
          <v-card
            height="100%"
          >
            <v-card-title primary-title>
              <div class="title">Dados Rastreabilidade</div>
            </v-card-title>
            <v-card-text>

              <v-layout row wrap>
                <v-flex xs12 md6>
                  <div class="grey--text">Chave Monitoramento</div>
                  <div>{{romaneio.hash_monitoramento}}</div>
                </v-flex>
                <v-flex xs12 md6>
                  <div class="grey--text">Track ID - Ecotrace</div>
                  <div>{{romaneio.track_id }}</div>
                </v-flex>
                <!-- <v-flex xs12>
                  <div class="grey--text">Hash Blockchains</div>
                  <div>&nbsp;</div>
                </v-flex> -->
              </v-layout>

              <div class="text-center">
                <v-dialog
                  v-model="dialogQrCode"
                  width="500"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="primary"
                      dark
                      v-on="on"
                    >
                      <v-icon>fa-qrcode</v-icon> &nbsp; Qrcode Rastreabilidade
                    </v-btn>
                  </template>

                  <v-card>
                    <v-card-title
                      class="headline info white--text"
                      primary-title
                    >
                      <v-icon>fa-qrcode</v-icon> &nbsp; Qrcode Rastreabilidade
                    </v-card-title>
                    <v-card-text class="text-center">
                      <br>
                      <div @click="openTrackPage" style="cursor: pointer;">
                        <qrcode :value="getUrlTrack()" :options="{ width: 300, margin : 1 }"></qrcode>               
                      </div>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <div class="flex-grow-1"></div>
                      <v-btn
                        color="primary"
                        text
                        @click="dialogQrCode = false"
                      >
                        Fechar
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
              

            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12>
          <v-card
            height="100%"
          >
            <v-card-title primary-title>
              <div class="title">Propriedade de origem</div>
            </v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 md4>
                  <div class="grey--text">Propriedade</div>
                  <div>{{romaneio.fazenda.nome}}</div>
                </v-flex>
                <v-flex xs12 md3>
                  <div class="grey--text">Cidade</div>
                  <div>{{romaneio.fazenda.cidade + "/" +romaneio.fazenda.estado }}</div>
                </v-flex>
                <v-flex xs12 md3>
                  <div class="grey--text">CPF / CNPJ</div>
                  <div>{{romaneio.produtor.cpf_cnpj}}</div>
                </v-flex>
                <v-flex xs12 md2>
                  <div class="grey--text">I.E.</div>
                  <div>{{romaneio.produtor.ie}}</div>
                </v-flex>
                <v-flex xs12>
                  <div class="grey--text">Produtor</div>
                  <div>{{romaneio.produtor.nome_razaosocial}}</div>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-card-title primary-title>
              <div class="title">Informações</div>
            </v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 md2>
                  <v-layout row wrap>
                    <v-flex xs6>Data do Abate</v-flex><v-flex xs6 class="text-right">{{romaneio.dt_abate | formatDate}}</v-flex>
                    <v-flex xs6>Hora de ínicio</v-flex><v-flex xs6 class="text-right">{{romaneio.hr_inicio | formatHour}}</v-flex>
                    <v-flex xs6>Hora do termino</v-flex><v-flex xs6 class="text-right">{{romaneio.hr_fim | formatHour}}</v-flex>
                    <v-flex xs6>Tempo total</v-flex><v-flex xs6 class="text-right">{{romaneio.tempo_total}} h</v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 md1></v-flex>
                <v-flex xs12 md2>
                  <v-layout row wrap>
                    <v-flex xs6>Nr. Lote</v-flex><v-flex xs6 class="text-right">{{romaneio.industria.nr_lote_abate}}</v-flex>
                    <v-flex xs6>Nr. Escala</v-flex><v-flex xs6 class="text-right">{{romaneio.industria.nr_escala_abate}}</v-flex>
                    <v-flex xs6>Sexo</v-flex><v-flex xs6 class="text-right">
                      {{romaneio.sexo == 'M' ? 'Macho' : 'Fêmea'}}
                    </v-flex>
                    <v-flex xs6>Contusão</v-flex><v-flex xs6 class="text-right">{{romaneio.porcentagem_contusoes}} %</v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 md1></v-flex>
                <v-flex xs12 md6>
                  <v-layout row wrap>
                    <v-flex xs12 md6>
                      <div class="text-center">
                        <div><strong>Análise Consistência</strong></div>
                        <div v-if="romaneio.flag_inconsistencia">
                          <v-icon style="font-size: 50px;" color="orange">fa-exclamation-circle</v-icon>
                        </div>
                        <div v-if="!romaneio.flag_inconsistencia">
                          <v-icon style="font-size: 50px;" color="green accent-4">fa-check-circle</v-icon>
                        </div>
                      </div>
                      <v-layout row wrap>
                        <v-flex xs6>
                          <div class="grey--text text-center">
                            <v-icon style="font-size: 20px;" color="orange">fa-exclamation-circle</v-icon>
                            <div>Inconsistente</div>
                          </div>
                        </v-flex>
                        <v-flex xs6>
                          <div class="grey--text text-center">
                            <v-icon style="font-size: 20px;" color="green accent-4">fa-check-circle</v-icon>
                            <div>Normal</div>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex xs12 md6>
                      <div class="text-center">
                        <div><strong>Classificação Lote</strong></div>
                        <div v-if="romaneio.classificacao_lote == 0">
                          <v-icon style="font-size: 50px;" color="green accent-4">fa-thumbs-up</v-icon>
                        </div>
                        <div v-if="romaneio.classificacao_lote == 1">
                          <v-icon style="font-size: 50px;" color="orange">fa-thumbs-up</v-icon>
                        </div>
                        <div v-if="romaneio.classificacao_lote == 2">
                          <v-icon style="font-size: 50px;" color="red darken-3">fa-thumbs-down</v-icon>
                        </div>
                      </div>
                      <v-layout row wrap>
                        <v-flex xs4>
                          <div class="grey--text text-center">
                            <v-icon style="font-size: 20px;" color="red darken-3">fa-thumbs-down</v-icon>
                            <div>Ruim</div>
                          </div>
                        </v-flex>
                        <v-flex xs4>
                          <div class="grey--text text-center">
                            <v-icon style="font-size: 20px;" color="orange">fa-thumbs-up</v-icon>
                            <div>Médio</div>
                          </div>
                        </v-flex>
                        <v-flex xs4>
                          <div class="grey--text text-center">
                            <v-icon style="font-size: 20px;" color="green accent-4">fa-thumbs-up</v-icon>
                            <div>Bom</div>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-flex>


                  </v-layout>
                </v-flex>
              </v-layout>

            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-card-title primary-title>
              <div class="title">Acabamento</div>
            </v-card-title>
            <v-card-text v-if="romaneio.acabamento">
              <v-layout>
                <v-flex xs4 class="text-center">
                  <doughnut-chart class="acabamento-graph" :chartdata="{data : romaneio.acabamento.desejavel, type : 'desejavel'}"></doughnut-chart>
                  <span>Mediana e Uniforme</span>
                </v-flex>

                <v-flex xs4 class="text-center">
                  <doughnut-chart class="acabamento-graph" :chartdata="{data : romaneio.acabamento.toleravel, type : 'toleravel'}"></doughnut-chart>
                  <span>Escassa</span>
                </v-flex>

                <v-flex xs4 class="text-center">
                  <doughnut-chart class="acabamento-graph" :chartdata="{data : romaneio.acabamento.indesejavel, type : 'indesejavel'}"></doughnut-chart>
                  <span>Ausente e Excessivo</span>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-card-text>
              <v-layout row wrap>

                <v-flex xs6 md3  class="text-center">
                  <div class="title">{{romaneio.qtde_cab}}</div>
                  <div>Quantidade Cabeças</div>
                  <br>
                  <div class="title">{{romaneio.media_rc}}%</div>
                  <div>Média de Rendimento</div>
                </v-flex>
                
                <v-flex xs6 md3  class="text-center">
                  <div class="title">{{romaneio.media_peso_vivo}} Kg</div>
                  <div>Média Peso Vivo</div>
                  <br>
                  <div class="title">{{romaneio.total_peso_carcaca}} Kg</div>
                  <div>Total</div>
                </v-flex>
                
                <v-flex xs6 md3  class="text-center">
                  <div class="title">{{romaneio.media_peso_carcaca}} Kg</div>
                  <div>Média de Carcaça</div>
                  <br>
                  <div class="title">{{romaneio.total_arroba}} @</div>
                  <div>Total</div>
                </v-flex>
                
                <v-flex xs6 md3  class="text-center">
                  <div class="title">{{romaneio.media_arroba}} @</div>
                  <div>Média Arroba</div>
                  <br>
                  <div class="title">{{romaneio.total_contusoes}}</div>
                  <div>Contusões</div>
                </v-flex>

              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-layout row wrap>

            <v-flex xs12 md3>
              <card-aux :labels="['Acabamento','	Qtde Cab.']" :title="'Acabamento'" :graphData="graphAcabemnto"></card-aux>
            </v-flex>

            <v-flex xs12 md3>
              <card-aux :labels="['Dentes','	Qtde Cab.']" :title="'Maturidade'" :graphData="graphMaturidade"></card-aux>
            </v-flex>

            <v-flex xs12 md3>
              <card-aux :labels="['Faixa','	Qtde Cab.']" :title="'Faixa de Pesos'" :graphData="graphFaixaPesos"></card-aux>
            </v-flex>

            <v-flex xs12 md3>
              <card-aux :labels="['Conformação','	Qtde Cab.']" :title="'Conformação'" :graphData="graphConformacao"></card-aux>
            </v-flex>

          </v-layout>
        </v-flex>

        <v-flex xs12>
          <v-layout row wrap>

            <v-flex xs12 md4>
              <card-dist :title="'Distribuição por Mercado'" :graphdata="graphDistMarket" :color="0"></card-dist>
            </v-flex>

            <v-flex xs12 md4>
              <card-dist :title="'Distribuição por Categoria'" :graphdata="graphDistCategoria" :color="1"></card-dist>
            </v-flex>

            <v-flex xs12 md4>
              <card-dist :title="'Distribuição por Raças'" :graphdata="graphDistRaca" :color="2"></card-dist>
            </v-flex>

          </v-layout>
        </v-flex>

        <v-flex xs12>
          <v-card>
            <v-card-title primary-title>
              <div class="title">Dispersão do Peso Vivo</div>
            </v-card-title>
            <v-card-text>
              <v-layout row wrap  v-if="graphDispersaoPesoVivo && graphDispersaoPesoVivo.desvioPadrao">
                <v-flex xs12 md6>
                  <div class="text-right">
                     <v-chip color="green" text-color="white"><strong>Desvio padrão: {{graphDispersaoPesoVivo.desvioPadrao}}</strong></v-chip>
                  </div>
                  <dispersao-chart :chartdata="graphDispersaoPesoVivo"></dispersao-chart>
                </v-flex>

                <v-flex xs12 md6>
                  <br>
                  <aux-chart :chartdata="pesosIntervalosVivo" :total="'value'"></aux-chart>
                </v-flex>
              </v-layout>

            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12>
          <v-card>
            <v-card-title primary-title>
              <div class="title">Dispersão do Peso de Carcaça</div>
            </v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <div class="text-right">
                     <v-chip color="green" text-color="white"><strong>Desvio padrão: {{graphDispersaoPesoCarcaca.desvioPadrao}}</strong></v-chip>
                  </div>
                  <dispersao-chart :chartdata="graphDispersaoPesoCarcaca"></dispersao-chart>
                </v-flex>
                  
                <v-flex xs12 md6>
                  <br>
                  <aux-chart :chartdata="pesosIntervalosCarcaca" :total="'value'"></aux-chart>
                </v-flex>
              </v-layout>

            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12>

          <v-card>
            <v-card-title primary-title>
              <div class="title">Lista de animais</div>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-card-text>
              <v-data-table
                v-if="tabledata"
                :headers="headers"
                :items="tabledata"
                :search="search"
                :mobile-breakpoint="960"
                sort-by="nr_sequencial_ind"
                disable-pagination
                hide-default-footer
                class="animals-table"
                dense
              >
                <template v-slot:item.flags="{ item }">
                  <div class="text-center">
                    <v-tooltip bottom v-if="item.flags.flag_contusao == 'S'">
                      <template v-slot:activator="{ on }">
                        <v-icon  v-on="on" size="25" color="red">fa-plus-circle</v-icon>
                      </template>
                      <span>Contusão</span>
                    </v-tooltip>
                    <span v-else>
                      Não
                    </span>
                  </div>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-btn  @click="showPicture(item.animal)" icon color="primary">
                    <v-icon size="20">fa-camera</v-icon>
                  </v-btn>
                </template>

                <template v-slot:item.peso_vivo="{ item }">
                  <span class="red--text" v-if="item.flags.flag_inconsistencia == 'S'"> 
                    {{item.peso_vivo}} 
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon  v-on="on" color="orange">fa-exclamation-circle</v-icon>
                      </template>
                      <span>Inconsistente</span>
                    </v-tooltip>
                  </span>
                  <span v-if="item.flags.flag_inconsistencia == 'N'"> {{item.peso_vivo}} </span>
                </template>

              </v-data-table>
              <div>
                <br>
                <v-icon color="orange">fa-exclamation-circle</v-icon> Inconsistente
                &nbsp;&nbsp;&nbsp;
                <v-icon size="20" color="red">fa-plus-circle</v-icon> Contusão
              </div>
            </v-card-text>
          </v-card>

        </v-flex>

      </v-layout>

      <image-modal v-model="openImage" :auxs="auxs" :animal="animal"></image-modal>

      <div class="text-center">
        <v-progress-circular
          indeterminate
          color="primary"
          v-if="load"
        ></v-progress-circular>
      </div>

    </v-container>

    <v-snackbar
      :timeout="3000"
      bottom
      right
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.text }}
      <v-btn dark text @click.native="snackbar.show = false" icon> 
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>


  </div>
</template>

<script>
import appApi from '../../plugins/api';
import ConfirmModal from '../../components/ConfirmModal';
import ImageModal from '../../components/romaneio/ImageModal';
import AcabamentoChart from '../../components/romaneio/AcabementoChart';
import AuxChart from '../../components/romaneio/AuxChart';
import CardAux from '../../components/romaneio/CardAux';
import CardDistribuicao from '../../components/romaneio/CardDistribuicao';
import DispersaoChart from '../../components/romaneio/DispersaoChart';
import RomaneioExample from './romaneioExample'

export default {
  components: {
    'app-confirm-modal' : ConfirmModal,
    'doughnut-chart' : AcabamentoChart,
    'aux-chart' : AuxChart,
    'card-aux' : CardAux,
    'card-dist' : CardDistribuicao,
    'dispersao-chart' : DispersaoChart,
    'image-modal' : ImageModal
  },
  data: function() {
    return {
      search : '',
      openImage : false,
      animal : '',
      romaneio : null,
      load : true,
      graphAcabemnto : null,
      graphMaturidade : null,
      graphFaixaPesos : null,
      graphConformacao : null,
      graphDistMarket : null,
      graphDistCategoria : null,
      graphDistRaca : null,
      graphDispersaoPesoVivo : null,
      graphDispersaoPesoCarcaca : null,
      pesosIntervalosVivo: null,
      pesosIntervalosCarcaca: null,
      approveRomaneio : null,
      snackbar : {},
      tabledata: [],
      headers : [
        { text: 'Seq', value: 'nr_sequencial_ind', sortable : true, class: ['animals-head'] },
        { text: 'Sisbov', value: 'st_sisbov', sortable : true, class: ['animals-head']},
        { text: 'Chip', value: 'st_chip', sortable : true, class: ['animals-head']},
        { text: 'Raça', value: 'breed_name', sortable : true, class: ['animals-head'] },
        { text: 'Categoria', value: 'category_name', sortable : true, class: ['animals-head'] },
        { text: 'PV', value: 'peso_vivo', sortable : true, class: ['animals-head'] },
        { text: 'P1+P2', value: 'total_carcaca', sortable : true, class: ['animals-head'] },
        { text: 'Rendimento', value: 'rendimento', sortable : true, class: ['animals-head'] },
        { text: 'Destino Abate', value: 'destiny_name', sortable : true, class: ['animals-head'] },
        { text: 'Contusão', value: 'flags', sortable : false, class: ['animals-head'] },
        { text: 'Ações', value: 'actions', sortable : false, class: ['animals-head'] },
      ],
      pagination : {rowsPerPage : -1},
      auxs : [],
      dialogQrCode : false
    }
  },

  computed: {
  },

  mounted: function() {
    window.scrollTo(0,0);
    if (this.$route.params.id) {

      appApi.getRomaneioAuxs().then( result => {
        this.auxs = result.data
        this.getRomaneio(this.$route.params.id);
      });      
    } else {
      this.load = false;
    }
  },

  methods: {
    getRomaneio: function(id) {

      if (id === 'exemplo') {
        this.romaneio = RomaneioExample
         this.calcAnimals()
        this.calcGraphAcabamento()
        this.calcgraphMaturidade()
        this.calcGraphFaixaPesos()
        this.calcGraphConformacao()
        this.calcGraphDistMarket()
        this.calcGraphDistCategoria()
        this.calcGraphDistRaca()
        this.calcGraphDispersaoChart('peso_vivo')
        this.calcGraphDispersaoChart('total_carcaca')
        this.calcGraphIntervaloPeso()
        this.getTableData()
        this.load = false;
        return;
      }

      appApi.getRomaneio(id).then(result => {
        this.romaneio = result.data;
        this.calcAnimals()
        this.calcGraphAcabamento()
        this.calcgraphMaturidade()
        this.calcGraphFaixaPesos()
        this.calcGraphConformacao()
        this.calcGraphDistMarket()
        this.calcGraphDistCategoria()
        this.calcGraphDistRaca()
        this.calcGraphDispersaoChart('peso_vivo')
        this.calcGraphDispersaoChart('total_carcaca')
        this.calcGraphIntervaloPeso()
        this.getTableData()
        this.load = false;
      }).catch(error => {
        this.load = false;
      });
    },

    calcAnimals: function() {
      try {
        
        let acabamento = {
          indesejavel : {total : 0, percent : 0}, 
          toleravel : {total : 0, percent : 0},
          desejavel : {total : 0, percent : 0},
        }

        let totalContusoes = 0;
        let totalInconsistencias = 0;

        for(let i=0; i < this.romaneio.animals.length; i++) {
            let animal = this.romaneio.animals[i];
            animal.flag_inconsistencia = animal.flag_inconsistencia ? animal.flag_inconsistencia : 'N';
            if (animal.flag_inconsistencia.toLowerCase().trim() === 's') {
              this.romaneio.flag_inconsistencia = true;
              totalInconsistencias++
            }

            animal.flag_contusao = animal.flag_contusao ? animal.flag_contusao : 'N';
            if (animal.flag_contusao.toLowerCase().trim() === 's') {
              totalContusoes++
            }

            //indesejavel : (100 / result.totalAnimais) * indesejavel
            if((animal.acabamento_id == '1') || (animal.acabamento_id == '5')) {
              acabamento.indesejavel.total++
              acabamento.indesejavel.percent = ((100 / this.romaneio.qtde_cab) * acabamento.indesejavel.total).toFixed(0)
            }
            if(animal.acabamento_id == '4') {
              acabamento.toleravel.total++
              acabamento.toleravel.percent = ((100 / this.romaneio.qtde_cab) * acabamento.toleravel.total).toFixed(0)
            }
            if((animal.acabamento_id == '3') || (animal.acabamento_id == '2')) {
              acabamento.desejavel.total++
              acabamento.desejavel.percent = ((100 / this.romaneio.qtde_cab) * acabamento.desejavel.total).toFixed(0)
            }
        }
        this.romaneio.classificacao_lote = this.calcClassificacaoLote(acabamento)
        this.romaneio.acabamento = acabamento
        this.romaneio.total_contusoes = totalContusoes
        this.romaneio.porcentagem_contusoes = ((100 / parseInt(this.romaneio.qtde_cab)) * totalContusoes).toFixed(2)

      
      } catch (error) {
       console.log(error) 
      }
    },


    calcClassificacaoLote(acabamentoStats) {

      //bom
      if (acabamentoStats.desejavel.percent >= 50) {
        return 0
      }
      //medio
      else if (acabamentoStats.desejavel.percent < 50 && acabamentoStats.indesejavel.percent < 25) {
        return 1
      }
      //ruim
      else {
        return 2
      }

    },

    calcGraphIntervaloPeso: function() {
      
      try {
        
        let intervalo = Math.floor( Math.sqrt(this.romaneio.qtde_cab) );

        let refLinesMaxVivo = 0;
        let refLinesMaxCarcaca = 0;
        let refLinesMinVivo = parseFloat(this.romaneio.animals[0].peso_vivo);
        let refLinesMinCarcaca = parseFloat(this.romaneio.animals[0].total_carcaca);

        for(let i=0; i < this.romaneio.animals.length; i++) {
          let animal = this.romaneio.animals[i];
          if (animal.peso_vivo > refLinesMaxVivo) {
            refLinesMaxVivo = animal.peso_vivo
          }
          if (animal.total_carcaca > refLinesMaxCarcaca) {
            refLinesMaxCarcaca = animal.total_carcaca
          }


          if (animal.peso_vivo < refLinesMinVivo) {
            refLinesMinVivo = animal.peso_vivo
          }
          if (animal.total_carcaca < refLinesMinCarcaca) {
            refLinesMinCarcaca = animal.total_carcaca
          }
        }

        let difVivo = Math.ceil(refLinesMaxVivo - refLinesMinVivo);
        let difCarcaca = Math.ceil(refLinesMaxCarcaca - refLinesMinCarcaca);

        let intervaloVivo = Math.ceil(difVivo / intervalo);
        let intervaloCarcaca = Math.ceil(difCarcaca / intervalo);

        let pesosIntervalosVivo = [];
        let pesosIntervalosCarcaca = [];

        for(let i=0;i<intervalo;i++) {

          let ini = Math.round(parseFloat(refLinesMinVivo) + (i * parseFloat(intervaloVivo)));
          let fim = Math.round(parseFloat(refLinesMinVivo) + ((i+1) * parseFloat(intervaloVivo)));
          pesosIntervalosVivo[i] = {
            name: "[" +  ini + '-' + fim + ']',
            ini: ini ,
            fim: fim,
            value: 0
          }

          let ini_carcaca = Math.round(parseFloat(refLinesMinCarcaca) + (i * parseFloat(intervaloCarcaca)));
          let fim_carcaca = Math.round(parseFloat(refLinesMinCarcaca) + ((i+1) * parseFloat(intervaloCarcaca)))
          pesosIntervalosCarcaca[i] = {
            name: "[" + ini_carcaca  + '-' + fim_carcaca + ']',
            ini: ini_carcaca ,
            fim: fim_carcaca,
            value: 0
          }
        }

        for(let i=0; i < this.romaneio.animals.length; i++) {
          let animal = this.romaneio.animals[i];
          let pesoVivo = Math.round(animal.peso_vivo ? animal.peso_vivo : 0) ;
          let pesoFinal = Math.round(parseFloat(animal.total_carcaca));

          for(let i=0;i<pesosIntervalosVivo.length;i++) {
            if((pesoVivo >= pesosIntervalosVivo[i].ini) && (pesoVivo < pesosIntervalosVivo[i].fim)) { pesosIntervalosVivo[i].value++; }
          }
          if((pesoVivo === pesosIntervalosVivo[pesosIntervalosVivo.length-1].fim)) { pesosIntervalosVivo[pesosIntervalosVivo.length-1].value++; }

          for(let i=0;i<pesosIntervalosCarcaca.length;i++) {
            if((pesoFinal >= pesosIntervalosCarcaca[i].ini) && (pesoFinal < pesosIntervalosCarcaca[i].fim)) { pesosIntervalosCarcaca[i].value++; }
          }
          if((pesoFinal === pesosIntervalosCarcaca[pesosIntervalosCarcaca.length-1].fim)) { pesosIntervalosCarcaca[pesosIntervalosCarcaca.length-1].value++; }
        }

        this.pesosIntervalosVivo = pesosIntervalosVivo
        this.pesosIntervalosCarcaca = pesosIntervalosCarcaca

      
      } catch (error) {
        console.log('error', error)
      }

    },

    calcGraphDispersaoChart: function(type) {
      let mediapeso = type === 'peso_vivo' ?  'media_peso_vivo' : 'media_peso_carcaca';
      let totalDispPesosVivo = {
        series : [],
        referenceLine :{ 
          value: (this.romaneio[mediapeso] ? parseFloat(this.romaneio[mediapeso]).toFixed(2) : 0),
          name: 'Média' 
        },
        desvioPadrao : 0
      }

      for(let i=0; i < this.romaneio.animals.length; i++) {
        let animal = this.romaneio.animals[i];

        totalDispPesosVivo.series.push({
          "name": animal.nr_sequencial_ind.toString(),
          "value": animal[type] ? animal[type] : 0,
          "label" : "Peso: "+(animal[type] ? animal[type] : 0) + "\n Nr Sequencial: " + animal.nr_sequencial_ind.toString(),
          "data" : [
            {
              x: animal.nr_sequencial_ind,
              y: animal[type] ? animal[type] : 0,
              r: 5
            }
          ],
          backgroundColor: '#2196F3',
          hoverBackgroundColor: '#3F51B5'
        });
      }

      let desvioPadrao = 0.0;
      
      totalDispPesosVivo.series.forEach(element => {
        let pow = Math.pow((parseFloat(element.value) - parseFloat(totalDispPesosVivo.referenceLine.value)), 2);
        desvioPadrao += pow;
      });
      totalDispPesosVivo.desvioPadrao = parseFloat(Math.sqrt((desvioPadrao / totalDispPesosVivo.series.length))).toFixed(2);

      if (type === 'peso_vivo') {
        this.graphDispersaoPesoVivo = totalDispPesosVivo
      } else {
        this.graphDispersaoPesoCarcaca = totalDispPesosVivo
      }
      
    },
    calcGraphDistCategoria: function() {

      let graphDistCategoria = {};
      for(let key in this.auxs['category']) {
        graphDistCategoria[key+""] = {name : this.auxs['category'][key], total : 0, percentage : 0}
      } 

      for(let i=0; i < this.romaneio.animals.length; i++) {
        const animal = this.romaneio.animals[i];
        if(graphDistCategoria[animal.categoria_id+""]) {
          graphDistCategoria[animal.categoria_id+""].total += 1;
          graphDistCategoria[animal.categoria_id+""].percentage = ((100/parseInt(this.romaneio.qtde_cab)) * graphDistCategoria[animal.categoria_id+""].total).toFixed(2);
        }
      }
      this.graphDistCategoria = graphDistCategoria;

    },

    calcGraphDistRaca: function() {
      let graphDistRaca = {};
      for(let key in this.auxs['breed']) {
        graphDistRaca[key+""] = {name : this.auxs['breed'][key], total : 0, percentage : 0}
      }

      for(let i=0; i < this.romaneio.animals.length; i++) {
        const animal = this.romaneio.animals[i];
        if(graphDistRaca[animal.raca_id+""]) {
          graphDistRaca[animal.raca_id+""].total += 1;
          graphDistRaca[animal.raca_id+""].percentage = ((100/parseInt(this.romaneio.qtde_cab)) * graphDistRaca[animal.raca_id+""].total).toFixed(2);
        }
      }
      
      let deleteValues = []

      for (let key in graphDistRaca) {
        if (graphDistRaca[key].total == 0) {
          deleteValues.push(key);
        }
      }

      for(let i=0; i < deleteValues.length; i++) {
        delete graphDistRaca[deleteValues[i]]
      }

      this.graphDistRaca = graphDistRaca;
    },

    calcGraphDistMarket: function() {

      let graphDistMarket = {};
      for(let key in this.auxs['market']) {
        graphDistMarket[key+""] = {name : this.auxs['market'][key], total : 0, percentage : 0}
      } 

      for(let i=0; i < this.romaneio.animals.length; i++) {
        const animal = this.romaneio.animals[i];
        if(graphDistMarket[animal.mercado_id+""]) {
          graphDistMarket[animal.mercado_id+""].total += 1;
          graphDistMarket[animal.mercado_id+""].percentage = ((100/parseInt(this.romaneio.qtde_cab)) * graphDistMarket[animal.mercado_id+""].total).toFixed(2);
        }
      }
      this.graphDistMarket = graphDistMarket;
    },

    calcGraphAcabamento: function() {
      let finish = this.auxs['finish']
      let graphAcabemnto = {};
      for(let key in finish) {
        graphAcabemnto[key] = {name : finish[key], total : 0, percentage : 0}
      } 

      for(let i=0; i < this.romaneio.animals.length; i++) {
        const animal = this.romaneio.animals[i];
        if(graphAcabemnto[animal.acabamento_id+""]) {
          graphAcabemnto[animal.acabamento_id+""].total += 1;
          graphAcabemnto[animal.acabamento_id+""].percentage = ((100/parseInt(this.romaneio.qtde_cab)) * graphAcabemnto[animal.acabamento_id+""].total).toFixed(2);
        }
      }
      this.graphAcabemnto = graphAcabemnto;
    },

    calcgraphMaturidade: function() {
      let graphMaturidade = {};

      for(let key in this.auxs['maturity']) {
        graphMaturidade[key+""] = {name : this.auxs['maturity'][key], total : 0, percentage : 0}
      } 

      for(let i=0; i < this.romaneio.animals.length; i++) {
        const animal = this.romaneio.animals[i];
        if(graphMaturidade[animal.maturidade_id+""]) {
          graphMaturidade[animal.maturidade_id+""].total += 1;
          graphMaturidade[animal.maturidade_id+""].percentage = ((100/parseInt(this.romaneio.qtde_cab)) * graphMaturidade[animal.maturidade_id+""].total).toFixed(2);
        }
      }
      this.graphMaturidade = graphMaturidade;
    },

    calcGraphFaixaPesos: function() {
      let pesos = [
        {name : 'Menor 15@', total : 0, percentage : 0},
        {name : '15 a 16@', total : 0, percentage : 0},
        {name : '16 a 18@', total : 0, percentage : 0},
        {name : '18 a 22@', total : 0, percentage : 0},
        {name : 'Maior 22@', total : 0, percentage : 0},
        {name : 'N/A', total : 0, percentage : 0},
      ]
      for(let i=0; i < this.romaneio.animals.length; i++) {
        const animal = this.romaneio.animals[i];
        const totalPesoArroba = (animal.total_carcaca/15)
          if(totalPesoArroba <= 15) { 
            pesos[0].total++; 
            pesos[0].percentage = ((100/parseInt(this.romaneio.qtde_cab)) * pesos[0].total).toFixed(2);; 
          }
          else if((totalPesoArroba > 15) && (totalPesoArroba <= 16)) { 
            pesos[1].total++; 
            pesos[1].percentage = ((100/parseInt(this.romaneio.qtde_cab)) * pesos[1].total).toFixed(2);;
          }
          else if((totalPesoArroba > 16) && (totalPesoArroba <= 18)) { 
            pesos[2].total++; 
            pesos[2].percentage = ((100/parseInt(this.romaneio.qtde_cab)) * pesos[2].total).toFixed(2);;
          }
          else if((totalPesoArroba > 18) && (totalPesoArroba <= 22)) { 
            pesos[3].total++; 
            pesos[3].percentage = ((100/parseInt(this.romaneio.qtde_cab)) * pesos[3].total).toFixed(2);;
          }
          else if(totalPesoArroba > 22) { 
            pesos[4].total++; 
            pesos[4].percentage = ((100/parseInt(this.romaneio.qtde_cab)) * pesos[4].total).toFixed(2);;
          }
      }

      this.graphFaixaPesos = pesos;
    },

    calcGraphConformacao : function() {

      let graphConformacao = {};
      for(let key in this.auxs['conformation']) {
        graphConformacao[key+""] = {name : this.auxs['conformation'][key], total : 0, percentage : 0}
      } 

      for(let i=0; i < this.romaneio.animals.length; i++) {
        const animal = this.romaneio.animals[i];
        if(graphConformacao[animal.conformacao_id+""]) {
          graphConformacao[animal.conformacao_id+""].total += 1;
          graphConformacao[animal.conformacao_id+""].percentage = ((100/parseInt(this.romaneio.qtde_cab)) * graphConformacao[animal.conformacao_id+""].total).toFixed(2);
        }
      }
      this.graphConformacao = graphConformacao;

    },
    
    getTableData() {
       let data = [] 
       this.romaneio.animals.forEach(animal => {
        this.tabledata.push({
          animal : animal,
          nr_sequencial_ind : animal.nr_sequencial_ind,
          st_sisbov: animal.st_sisbov,
          st_chip: animal.st_chip,
          breed_name: this.auxs['breed'][animal.raca_id] ? this.auxs['breed'][animal.raca_id] : '',
          category_name: this.auxs['category'][animal.categoria_id] ? this.auxs['category'][animal.categoria_id] : '',
          peso_vivo: !isNaN(parseFloat(animal.peso_vivo)) ? parseFloat(animal.peso_vivo).toFixed(0) + " Kg" : 0,
          peso_final_carcaca_1: animal.peso_final_carcaca_1,
          peso_final_carcaca_2: animal.peso_final_carcaca_2,
          total_carcaca: animal.total_carcaca + " Kg",
          rendimento: animal.rendimento + "%",
          finish_name: this.auxs['finish'][animal.acabamento_id] ? this.auxs['finish'][animal.acabamento_id] : '',
          conformation_name : this.auxs['conformation'][animal.conformacao_id] ? this.auxs['conformation'][animal.conformacao_id] : '',
          maturity_name : this.auxs['maturity'][animal.maturidade_id] ? this.auxs['maturity'][animal.maturidade_id] : '',
          destiny_name : this.auxs['destiny'][animal.destino_id] ? this.auxs['destiny'][animal.destino_id] : '',
          flags : { flag_contusao : animal.flag_contusao, flag_inconsistencia : animal.flag_inconsistencia },
          actions : ''
        });
      });
    },

    showPicture(animal) {
      this.openImage = true;
      this.animal = null;
      appApi.getRomaneioImages(animal.track_id, animal.nr_sequencial_ind)
        .then(result => {
          this.animal = animal;
          this.animal['image'] = result.data[0][0]
        })
    },

    getUrlTrack() {
      let props = this.$router.resolve({ 
        name: 'Track',
        query: { track_id : this.romaneio.track_id },
      });

      return process.env.VUE_APP_URL_TRACK ? process.env.VUE_APP_URL_TRACK + props.href : props.href;
    },

    openTrackPage() {
      let url = this.getUrlTrack()
      window.open(url, '_system', '');
    }

  }

};
</script>
<style scoped lang="css">
  #pageRomaneio {
    position: relative;
  }
  #pageRomaneio .btn-feedback {
    top: -38px;
    left: calc(100% - 150px);
  }
  #pageRomaneio .btn-add {
    position: fixed;
    top: 90px;
    left: calc(100% - 60px);
  }
  #pageRomaneio .card-romaneio {
    margin-bottom: 10px;
  }

  #pageRomaneio .romaneio-label {
    display: block;
  }

  #pageRomaneio .acabamento-graph {
    position: relative;
    max-height: 150px;
  }

  #pageRomaneio .aux-chart {
    margin-top: 10px;
    position: relative;
    height: 250px;
  }

  #pageRomaneio .animals-table table.v-table thead th {
    background-color: #455A64;
    color: #fff;
  }

  #pageRomaneio .theme--light.v-card .v-card__text {
    color: #212121;
  }

  .animals-table >>>.v-data-table-header.v-data-table-header-mobile {
    display: none !important;
  }
  .animals-table >>>tbody tr .v-data-table__mobile-row:nth-of-type(odd) {
    background-color: rgba(0,0,0,.05);
  }

  @media screen and (max-width: 960px) {
    #pageRomaneio >>>.animals-table.theme--light.v-data-table tbody tr td:first-child,
    #pageRomaneio >>>.animals-table.theme--light.v-data-table tbody tr:not(:last-child) td:last-child {
      border: 0px;
    }
    
    .animals-table >>>tbody tr {
      border: 1px solid #e4e4e4;
      display: block;
      margin-bottom: 10px;
      border-radius: 4px;
      padding-bottom: 10px;
      overflow: hidden;
      box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
    }
  }

</style>

